(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.factory('profileUserTableLogic', ["userDao", "columnsHelper", "tablePaginationHelper", "$q", "widgetPolling", function (userDao, columnsHelper, tablePaginationHelper, $q, widgetPolling) {
        return function ($scope, logic) {
            var id = widgetPolling.scope().id;
            if (_($scope.model.wrapper.showLoading).isUndefined()) {
                $scope.model.wrapper.showLoading = true;
            }
            $scope.model.wrapper.isLoading = true;
            $scope.tableOptions = {
                pagesAround: 2,
                pageSize: 10,
                pagination: {
                    page: 1,
                    ordering: {}
                }
            };
            var options = {
                columns: $scope.model.columns,
                options: { autoUpdate: logic.updateTick }
            };
            logic.updateTick = null;
            $scope.tableHelper = tablePaginationHelper($scope, $scope.model.options, options, function (args) {
                var q = userDao[logic.type](id, logic.entityType || widgetPolling.scope().entityType, $scope.model.columns);
                if (args.columnsFilters) {
                    q.params(columnsHelper.filtersToParams(args.columnsFilters));
                }
                return q.pagination(args.offset, args.limit);
            }, function (tableModel) {
                $scope.model.wrapper.isLoading = false;
                $scope.model.wrapper.showLoading = false;
                if (!_(tableModel).isNull()) {
                    $scope.model.pagination = tableModel.pagination;
                    $scope.model.data = tableModel.data;
                    $scope.model.selected = tableModel.selected;
                    $scope.model.rowClasses = tableModel.rowClasses;
                }
            });
            return function () {
                $scope.tableHelper.destroy();
            };
        };
    }]);
}());